var exports = {
  "i": "xaee3c4fa--19a103--wrapper",
};

module.exports = exports;
